import React from "react";
import { FiExternalLink, FiMapPin } from "react-icons/fi";

export default function ServiceMapPanel({ service }) {
  if (!service?.mapEmbedUrl) return null;

  return (
    <div className="mt-5 overflow-hidden rounded-[1.75rem] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-950">
      <div className="flex flex-col gap-3 border-b border-slate-200 bg-slate-50 px-4 py-3 dark:border-slate-800 dark:bg-slate-900 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-center gap-2 text-sm font-bold text-slate-800 dark:text-slate-100">
          <span className="inline-flex h-9 w-9 items-center justify-center rounded-2xl bg-[#1277B9]/10 text-[#1277B9] dark:bg-[#1277B9]/20 dark:text-sky-300">
            <FiMapPin className="h-4 w-4" />
          </span>
          Localisation du service
        </div>

        {service.mapsHref && (
          <a
            href={service.mapsHref}
            target="_blank"
            rel="noreferrer"
            className="inline-flex min-h-10 items-center justify-center gap-2 rounded-2xl border border-slate-200 bg-white px-4 text-sm font-bold text-slate-700 transition hover:border-[#1277B9]/50 hover:bg-sky-50 hover:text-[#1277B9] dark:border-slate-700 dark:bg-slate-950 dark:text-slate-100 dark:hover:bg-slate-800"
          >
            Ouvrir dans Google Maps
            <FiExternalLink className="h-4 w-4" />
          </a>
        )}
      </div>

      <div className="h-72 w-full bg-slate-100 dark:bg-slate-900 sm:h-80">
        <iframe
          title={`Carte - ${service.title}`}
          src={service.mapEmbedUrl}
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          className="h-full w-full border-0"
        />
      </div>
    </div>
  );
}